<template>
  <div class="privacy-page">
    <h1>
      {{ $t("privacy_policy") }}
    </h1>

    <p>
      <strong> Verantwortlicher für die Datenverarbeitung:<br /> </strong>
      Tuemedia IT Solutions<br />
      Frederik Reiff<br />
      Claushof 43<br />
      46535 Dinslaken<br />
      Telefon: +49 (0) 15733356316<br />
      E-Mail: info@tuemedia-it.de<br /><br />

      <strong> Vertreten durch:<br /> </strong>
      Frederik Reiff<br />
      E-Mail: reiff@tuemedia-it.de<br /><br />
    </p>

    <ul>
      <li>
        <p class="li-title">1. Allgemeines zur Datenverarbeitung</p>
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns wichtig. Diese
          Datenschutzerklärung erläutert, welche personenbezogenen Daten wir im
          Zusammenhang mit der Nutzung unserer Software "ChronoFox" verarbeiten,
          zu welchen Zwecken und auf welcher Rechtsgrundlage dies erfolgt, und
          welche Rechte Ihnen zustehen.
        </p>
      </li>

      <li>
        <p class="li-title">2. Hosting und technische Infrastruktur</p>

        <p>
          Die Software wird auf den Servern der Netcup GmbH, Daimlerstraße 25,
          D-76185 Karlsruhe, gehostet. Die Server befinden sich ausschließlich
          in Deutschland, was bedeutet, dass die Datenverarbeitung innerhalb der
          EU erfolgt und den strengen Anforderungen der DSGVO unterliegt.
        </p>
      </li>

      <li>
        <p class="li-title">3. Verarbeitete Datenkategorien</p>

        <p>
          Um die Nutzung unserer Software zu ermöglichen und die Funktionen
          bereitzustellen, verarbeiten wir folgende personenbezogenen Daten:<br />

          Benutzerkonto-Daten (E-Mail-Adresse und Passwort)<br />
          Unternehmensdaten (Unternehmensname, Unternehmensgröße,
          Unternehmensadresse)<br />
          Kunden- und Projektdaten (Name, Adresse, Kontaktinformationen)<br />
          Zeiterfassungsdaten (Stundensätze, Arbeitszeiten)<br />
        </p>
      </li>

      <li>
        <p class="li-title">4. Verwendungszwecke und Rechtsgrundlage</p>

        <p>
          Die Verarbeitung der Daten erfolgt zur Bereitstellung der
          Softwarefunktionen und zur Durchführung von Abrechnungen.
          Rechtsgrundlage hierfür ist Art. 6 Abs. 1 lit. b DSGVO
          (Vertragserfüllung). Zudem erfolgt die Speicherung von Rechnungsdaten
          gemäß Art. 6 Abs. 1 lit. c DSGVO (gesetzliche Verpflichtung), solange
          die Rechnung offen ist.
        </p>
      </li>

      <li>
        <p class="li-title">5. Datenweitergabe an Dritte</p>

        <p>
          Eine Weitergabe personenbezogener Daten erfolgt an Lexoffice, eine
          Software zur Abrechnungserstellung. Derzeit erfolgt dies manuell,
          künftig jedoch automatisiert. Eine gesonderte Vereinbarung zur
          Datenverarbeitung im Auftrag wird mit Lexoffice geschlossen.
        </p>
      </li>

      <li>
        <p class="li-title">6. Sicherheitsmaßnahmen</p>

        <p>
          Wir setzen technische und organisatorische Maßnahmen ein, um die
          Sicherheit der verarbeiteten Daten zu gewährleisten. Dazu gehören:<br />

          Passwort-Hashing und SSL-Verschlüsselung<br />
          Einsatz von Firewalls und regelmäßige Backups (wöchentlich)<br />
          Beschränkung des Datenbank- und Backend-Zugriffs<br />
          Der Schutz des Zugriffs durch Zuordnung der Daten zu einem
          Unternehmen<br />
        </p>
      </li>

      <li>
        <p class="li-title">7. Speicherdauer und Löschung</p>

        <p>
          Personenbezogene Daten werden nur so lange gespeichert, wie dies zur
          Vertragserfüllung oder aufgrund gesetzlicher Vorgaben notwendig ist.
          Nach Kündigung des Abonnements löschen wir alle Zeiteinträge und
          Aktivitäten. Unternehmens- und Abrechnungsdaten werden solange
          gespeichert, bis alle offenen Rechnungen beglichen wurden.
        </p>
      </li>

      <li>
        <p class="li-title">8. Multi-User Zugriff</p>

        <p>
          Innerhalb eines Unternehmens können alle registrierten Benutzer die
          Zeiteinträge und Projektdaten anderer Benutzer desselben Unternehmens
          einsehen. Diese umfassende Transparenz ist notwendig, um die
          Funktionalität der Software zur Abrechnung zu gewährleisten.
        </p>
      </li>

      <li>
        <p class="li-title">9. Cookies und technische Tools</p>

        <p class="li-bold">Einsatz von Cookies</p>

        <p>
          Cookies sind kleine Textdateien oder sonstige Speichervermerke, die
          Informationen auf Endgeräten speichern und auslesen. Sie können dazu
          dienen, technische Funktionen bereitzustellen (z. B. Login-Status oder
          Warenkorbinhalte) oder Analysen zur Nutzung unserer Website zu
          ermöglichen.
        </p>

        <p>
          Wir setzen Cookies im Einklang mit den gesetzlichen Vorschriften ein.
          Eine vorherige Einwilligung der Benutzer holen wir nur ein, wenn diese
          gesetzlich erforderlich ist. Eine Einwilligung ist nicht erforderlich,
          wenn Cookies ausschließlich notwendig sind, um einen von Ihnen
          ausdrücklich gewünschten Telemediendienst bereitzustellen. Sie können
          Ihre Einwilligung jederzeit über die Cookie-Einstellungen auf unserer
          Website widerrufen.
        </p>

        <br />

        <p class="li-bold">Arten von Cookies:</p>
        <ul>
          <li>
            Temporäre Cookies (Session-Cookies): Diese werden automatisch
            gelöscht, wenn Sie Ihr Endgerät oder den Browser schließen.
          </li>
          <li>
            Permanente Cookies: Diese bleiben über einen bestimmten Zeitraum
            gespeichert, um beispielsweise Ihren Login-Status oder bevorzugte
            Einstellungen zu speichern.
          </li>
        </ul>
        <p>
          Falls keine abweichenden Angaben gemacht werden, beträgt die
          Speicherdauer von Cookies bis zu zwei Jahre.
        </p>

        <br />

        <p class="li-bold">Widerspruch und Opt-Out:</p>

        <p>
          Sie können Ihre Cookie-Einstellungen jederzeit ändern und der Nutzung
          nicht notwendiger Cookies widersprechen. Zudem können Sie Cookies über
          die Einstellungen Ihres Browsers deaktivieren oder bereits
          gespeicherte Cookies löschen.
        </p>

        <br />

        <p class="li-bold">Google Analytics</p>

        <p>
          Wir nutzen Google Analytics, einen Webanalysedienst von Google LLC
          („Google“). Google Analytics verwendet Cookies, die eine Analyse Ihrer
          Nutzung unserer Website ermöglichen. Die durch das Cookie erzeugten
          Informationen über Ihre Nutzung unserer Website (einschließlich Ihrer
          IP-Adresse, die jedoch durch IP-Anonymisierung gekürzt wird) werden in
          der Regel an einen Server von Google in den USA übertragen und dort
          gespeichert. Google Analytics erfasst unter anderem: Besuchsdauer
          aufgerufene Seiten Herkunftsquelle des Besuchs technische
          Informationen (z. B. Gerätetyp, Browser) Die Verarbeitung erfolgt auf
          Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
          der Analyse des Benutzerverhaltens zur Optimierung unseres Angebots).
          Falls eine Einwilligung erforderlich ist, erfolgt die Verarbeitung auf
          Grundlage von Art. 6 Abs. 1 lit. a DSGVO. <br /><br />
          Sie können die Erfassung Ihrer Daten durch Google Analytics
          verhindern, indem Sie in den Cookie-Einstellungen auf unserer Website
          die Analyse-Cookies deaktivieren oder ein Browser-Add-on zur
          Deaktivierung von Google Analytics nutzen:
          <a href="https://tools.google.com/dlpage/gaoptout"
            >https://tools.google.com/dlpage/gaoptout</a
          >
          <br />
          Weitere Informationen zur Datenverarbeitung durch Google Analytics
          finden Sie in der Datenschutzerklärung von Google:
          <a href="https://policies.google.com/privacy"
            >https://policies.google.com/privacy</a
          >
        </p>
      </li>

      <li>
        <p class="li-title">10. Ihre Rechte</p>

        <p>
          Sie haben das Recht, jederzeit Auskunft über die von uns verarbeiteten
          personenbezogenen Daten zu erhalten. Zudem können Sie die
          Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer Daten
          verlangen, soweit dem keine gesetzlichen Aufbewahrungspflichten
          entgegenstehen. Weiterhin haben Sie das Recht auf Datenübertragbarkeit
          sowie das Recht, sich bei einer Aufsichtsbehörde zu beschweren.
        </p>
      </li>

      <li>
        <p class="li-title">11. Vertrag zur Auftragsverarbeitung</p>

        <p>
          Als SaaS-Anbieter stellen wir bei Bedarf einen Vertrag zur
          Auftragsverarbeitung bereit, um den Anforderungen der DSGVO zu
          entsprechen.
        </p>
      </li>

      <li>
        <p class="li-title">12. Änderungen der Datenschutzerklärung</p>

        <p>
          Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf zu ändern.
          Die jeweils aktuelle Version finden Sie auf unserer Website. Bei
          wesentlichen Änderungen informieren wir Sie per E-Mail.
        </p>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "website",
});

const { t } = useI18n();
useSeoMeta({
  title: t("privacy_policy") + " - " + "ChronoFox",
});
</script>

<style scoped>
.privacy-page {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  max-width: 900px;
  margin: 0 auto;
  padding: 60px 20px 80px;
  line-height: 1.8;
  color: #2c3e50;
}

.privacy-page h1 {
  font-size: 3rem;
  font-weight: 700;
  color: var(--t-accent);
  margin: 0 0 3rem 0;
  width: 100%;
  text-align: center;
  padding-bottom: 1rem;
  border-bottom: 3px solid var(--t-accent);
}

.privacy-page > p {
  background-color: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 2.5rem;
  border-left: 4px solid var(--t-accent);
}

.privacy-page ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.privacy-page > ul > li {
  margin-bottom: 3rem;
  padding: 2rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.privacy-page > ul > li:hover {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  transform: translateY(-2px);
}

.privacy-page .li-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: var(--t-accent);
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid var(--t-accent);
}

.privacy-page .li-bold {
  font-weight: 700;
  color: #34495e;
  margin-top: 1.5rem;
  display: block;
}

.privacy-page p {
  font-size: 1.05rem;
  margin-bottom: 1rem;
  text-align: justify;
}

.privacy-page li ul {
  list-style: disc;
  margin-left: 2rem;
  margin-top: 1rem;
}

.privacy-page li ul li {
  margin-bottom: 0.8rem;
  padding: 0.5rem 0;
}

.privacy-page a {
  color: var(--t-accent);
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  word-break: break-all;
}

.privacy-page a:hover {
  text-decoration: underline;
  color: var(--secondary-text-color);
}

@media (max-width: 768px) {
  .privacy-page {
    padding: 40px 15px 60px;
  }

  .privacy-page h1 {
    font-size: 2.2rem;
    margin-bottom: 2rem;
  }

  .privacy-page > ul > li {
    padding: 1.5rem;
    margin-bottom: 2rem;
  }

  .privacy-page .li-title {
    font-size: 1.3rem;
  }

  .privacy-page p {
    font-size: 1rem;
  }
}
</style>
